// src/components/common/LoadingComponent.jsx
import Lottie from "lottie-react";
import Loader from "../../assets/lottie/Loader-v1.json";

const LoadingComponent = () => {
  return (
    <div className="flex justify-center items-center h-screen">
  <div className="w-[250px]">
        <Lottie animationData={Loader} loop={true} />
      </div>
    </div>
  );
};

export default LoadingComponent;